<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import './Common/css/font.css'
export default {
  name: 'App',
  data(){
    return{}
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
 .toastCss{
    width: 50% !important;
    height: 4% ;
    font-size: 30px !important;

} */
</style>



// WEBPACK FOOTER //
// src/App.vue